"use strict";
/**
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _classCallCheck = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // tslint:disable: no-any
// tslint:disable: class-name
// tslint:disable: variable-name
// tslint:disable: jsdoc-format
// tslint:disable: no-namespace

var bigtableadmin_v1;

(function (bigtableadmin_v1) {
  /**
   * Cloud Bigtable Admin API
   *
   * Administer your Cloud Bigtable tables and instances.
   *
   * @example
   * const {google} = require('googleapis');
   * const bigtableadmin = google.bigtableadmin('v1');
   *
   * @namespace bigtableadmin
   * @type {Function}
   * @version v1
   * @variation v1
   * @param {object=} options Options for Bigtableadmin
   */
  var Bigtableadmin = function Bigtableadmin(options, google) {
    _classCallCheck(this, Bigtableadmin);

    this.context = {
      _options: options || {},
      google: google
    };
  };

  bigtableadmin_v1.Bigtableadmin = Bigtableadmin;
})(bigtableadmin_v1 = exports.bigtableadmin_v1 || (exports.bigtableadmin_v1 = {}));